var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "work"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7310_77179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7310_77179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "work_2",
    d: "M2.87167 13.6667C2.53489 13.6667 2.24984 13.55 2.0165 13.3167C1.78317 13.0833 1.6665 12.7983 1.6665 12.4615V5.5385C1.6665 5.20172 1.78317 4.91667 2.0165 4.68333C2.24984 4.45 2.53489 4.33333 2.87167 4.33333H5.6665V3.20517C5.6665 2.86839 5.78317 2.58333 6.0165 2.35C6.24984 2.11667 6.53489 2 6.87167 2H9.128C9.46478 2 9.74984 2.11667 9.98317 2.35C10.2165 2.58333 10.3332 2.86839 10.3332 3.20517V4.33333H13.128C13.4648 4.33333 13.7498 4.45 13.9832 4.68333C14.2165 4.91667 14.3332 5.20172 14.3332 5.5385V12.4615C14.3332 12.7983 14.2165 13.0833 13.9832 13.3167C13.7498 13.55 13.4648 13.6667 13.128 13.6667H2.87167ZM2.87167 12.6667H13.128C13.1793 12.6667 13.2263 12.6453 13.269 12.6025C13.3118 12.5598 13.3332 12.5128 13.3332 12.4615V5.5385C13.3332 5.48717 13.3118 5.44017 13.269 5.3975C13.2263 5.35472 13.1793 5.33333 13.128 5.33333H2.87167C2.82034 5.33333 2.77334 5.35472 2.73067 5.3975C2.68789 5.44017 2.6665 5.48717 2.6665 5.5385V12.4615C2.6665 12.5128 2.68789 12.5598 2.73067 12.6025C2.77334 12.6453 2.82034 12.6667 2.87167 12.6667ZM6.6665 4.33333H9.33317V3.20517C9.33317 3.15383 9.31178 3.10683 9.269 3.06417C9.22634 3.02139 9.17934 3 9.128 3H6.87167C6.82034 3 6.77334 3.02139 6.73067 3.06417C6.68789 3.10683 6.6665 3.15383 6.6665 3.20517V4.33333Z",
    fill: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.ddf1c572ee0e4cb06bd1eca70e8c6f7c.svg";
export { ForwardRef as ReactComponent };